import { useEffect, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible, AiOutlineInfoCircle } from "react-icons/ai";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  loginWithEmailAndPassword,
  registerWithEmailAndPassword,
  reset,
} from "../../../redux/auth/authSlice";
import SlideComp from "../../../components/layout/Slide";

import Loader from "../../../components/Loader";
import { toast } from "react-toastify";
import Layout from "../../../components/layout/Layout";
import { Button, Dropdown } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import axios from "axios";
import countries from "countries-list";
import { blobURL } from "common/StringUtils";
import { Helmet } from "react-helmet";
import CheckboxUI from "components/CheckboxUI";
import { DiscoverInvozio } from "../DiscoverInvozio";
import { LOCALES } from "common/constants";
import { specialCharacterTest } from "common/Regex";
import CryptoJS from "crypto-js";

const CreateAccount = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const language = localStorage.getItem("i18nextLng");

  // Validation function for text fields (allows a-z, A-Z, 0-9, space, comma, and Swedish characters)
  const validateTextInput = (value) => {
    const allowedPattern = /^[a-zA-Z0-9 ,ÖÄÅöäå]*$/;
    return allowedPattern.test(value);
  };

  const handleTextInputChange = (e) => {
    const value = e.target.value;
    if (!validateTextInput(value)) {
      // Remove invalid characters
      e.target.value = value.replace(/[^a-zA-Z0-9 ,ÖÄÅöäå]/g, '');
    }
  };
  const invoicePDF = `${blobURL}/invoice.pdf`;
  const invoiceSwidishPDF = `${blobURL}/invoiceSwidish.pdf`;
  const workAgrementSwedish = `${blobURL}/Allmänt avtal för Egenanställning.pdf`;
  const workAgrementEnglish = `${blobURL}/General Contract for Self-Employment.pdf`;

  const [show, setShow] = useState({
    value: "",
    show: false,
    complete: false,
    acception: true,
    errorMessage: false,
    successMessage: false,
    completeSuccessful: false,
  });

  const [passVisible, setPassVisibile] = useState(false);
  const [invalidPasswordChars, setInvalidPasswordChars] = useState([]);
  const [DOBValue, setDOBValue] = useState("");
  const [isAmbassador, setAmbassador] = useState(false);
  const [socialPlatformId, setSocialPlatformId] = useState("");
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [hideNote, setHideNote] = useState(false);
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    watch,
    setValue,
    register,
    handleSubmit,
    trigger,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm();

  const bankName = watch("bank");

  const { isLoading, isError, message, userData } = useSelector(
    (state) => state.auth
  );

  const accountType = sessionStorage.getItem("accountType");

  const dateOfBirth = watch("DOB");
  const ssnNumber = watch("ssn");
  const { bankDetails } = useSelector((details) => details.auth);

  const fetchSocialPlatformId = async (platformId) => {
    try {
      const res = await axios.get(
        `adminsocialusers/data?data=${platformId}`,
        {}
      );
      if (res.data.response.isValid) {
        setSocialPlatformId(res.data.response.id);
      }
    } catch (err) {
      navigate("/error");
    }
  };
  useEffect(() => {
    setData(bankDetails[0]);
  }, [bankDetails]);
  useEffect(() => {
    if (["Foreign bank BIC / IBAN", "Revolut Bank"].includes(bankName)) {
      setHideNote(true);
    } else {
      setHideNote(false);
    }
  }, [bankName]);

  useEffect(() => {
    sessionStorage.setItem("invitationUserId", searchParams.get("userId"));
    sessionStorage.setItem(
      "freelancerInvitated",
      searchParams.get("isFreelancerInvitated")
    );
    // setSearchParams({});
    const getisAmbassador = searchParams.get("ambassador");
    const getSocialPlatformId = searchParams.get("SocialPlatformId");
    const encoded = encodeURIComponent(getSocialPlatformId);
    if (getisAmbassador) {
      setAmbassador(getisAmbassador);
    } else {
      setAmbassador(false);
    }

    if (encoded !== "null") {
      fetchSocialPlatformId(encoded);
    }
  }, [searchParams, fetchSocialPlatformId]);

   const freelancerInvitated = searchParams.get("isFreelancerInvitated");
  useEffect(() => {
    if (accountType === "2") {
      setValue("lastName", "");
    }
  }, [accountType, setValue]);

  useEffect(() => {
    if (dateOfBirth) {
      setValue("ssn", "");
    } else {
      setValue("DOB", "");
    }
  }, [dateOfBirth, setValue]);

  useEffect(() => {
    return () => dispatch(reset());
  }, [dispatch]);

  // useEffect(() => {
  //   if (isSuccess) {
  //     navigate(`/thankyou/${watch("email")}`);
  //   }
  // }, [isSuccess, dispatch, navigate]);

  useEffect(() => {
    if (
      message ===
      "Request failed: Det finns ingen användare kopplad till den här anställda."
    ) {
      toast.error(t("There is no user associated with this employee."));
    } else {
      if (isError) toast.error(t(message));
    }
  }, [isError, message, t]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    trigger();
  }, [language]);

  const validatePasswordChars = (password) => {
    const allowedChars = /^[A-Za-z\d@$!%*?&]*$/;
    const invalidChars = [];
    
    for (let i = 0; i < password.length; i++) {
      const char = password[i];
      if (!allowedChars.test(char) && !invalidChars.includes(char)) {
        invalidChars.push(char);
      }
    }
    
    setInvalidPasswordChars(invalidChars);
    return invalidChars.length === 0;
  };

  let isValidated;
  const validateClearingNumber = (value) => {
    isValidated = specialCharacterTest(value);
    if (!isValidated) {
      setError("clearingNumber", {
        type: "manual",
        message: `${t(
          "Please do not enter hyphen and any other special character"
        )}`,
      });
    } else {
      clearErrors("clearingNumber");
    }
    return true;
  };

  const validateAccountNumber = (value) => {
    isValidated = specialCharacterTest(value);
    if (!isValidated) {
      setError("accountNumber", {
        type: "manual",
        message: `${t(
          "Please do not enter hyphen and any other special character"
        )}`,
      });
    } else {
      clearErrors("accountNumber");
    }
    return true;
  };

  const newDetails = [];
  Object.keys(countries.countries).forEach((code) => {
    // if (countries.countries[code].continent === "EU") {
    newDetails.push(countries.countries[code].name);
    // }
  });
  newDetails.splice(45, 1);

  const loginUserIfRegistred = async (email, password) => {
    const response = await dispatch(
      loginWithEmailAndPassword({
        email: email,
        password: password,
      })
    );

    if (response?.payload === "account_deactivated") {
      settoggleReactivate(true);
    }

    if (response?.payload === "inactive_account") {
      settoggleReactivate(true);
      setInactiveAccount(true);
    }

    if (response && typeof response.payload === "object") {
      toast.success(t("Logged in successfully"));
    }
  };
  const onSubmit = async (values) => {
    const isNotEmpty = (value) => value.trim() !== "";

    const requiredFields = [
      "firstName",
      "profession",
      "address",
      "city",
      "country",
      "postal",
    ];

    if (accountType !== "2") {
      requiredFields.push("lastName");
    }

    const areAllFieldsValid = requiredFields.every((field) =>
      isNotEmpty(values[field])
    );

    if (!areAllFieldsValid) {
      toast.error(t("Empty spaces are not permitted"));
    } else {
      if (!DOBValue && ssnNumber?.length < 12) {
        toast.error(t("SSN number must have 12 digits."));
      } else {
        if (!ssnNumber && DOBValue?.length < 11) {
          toast.error(t("DOB must have 11 digits."));
        } else {
          if (
            values.email === values.confirmEmail &&
            values.password === values.confirmPassword
          ) {
            const { DOB, ...updatedValues } = values;
            if (!DOBValue) {
              updatedValues.dateBirth = "";
              updatedValues.dateOfBirth = "";
            }
            const response = await dispatch(
              registerWithEmailAndPassword({
                ...updatedValues,
                id: 0,
                organisation: "",
                accountType: accountType || 1,
                invitedBy:
                  sessionStorage.getItem("invitationUserId") === "null"
                    ? 0
                    : sessionStorage.getItem("invitationUserId") || 0,
                dateOfBirth: DOBValue
                  ? values.ssn === ""
                    ? values?.dateBirth || ""
                    : values?.dateBirth || ""
                  : "",
                invitedByAmbassador: isAmbassador,
                socialPlatformId,
                profession: values?.profession,
                address: values?.address,
                city: values?.city,
                country: values?.country,
                zipCode: values?.postal,
                accountNumber: values?.accountNumber || "",
                bank: values?.bank || "",
                clearingNumber: values?.clearingNumber || "",
                ibanNumber: values?.ibanNumber || "",
                bicNumber: values?.bicNumber || "",
                otherBank: values?.OtherBank || "",
                language,
              })
            );

            if (response && response.payload.statusCode === 200) {
              // Push event to dataLayer directly in JS
              window.dataLayer = window.dataLayer || [];
              await pushHashedEmail(values);
              // const isProduction = import.meta.env.VITE_NODE_ENV === "production";
              // if (typeof window !== "undefined" && window.dataLayer && isProduction) {
              //   window.dataLayer.push({
              //     event: "create_account"
              //   });
              // }
              if (userData?.response?.userId) {
                await loginUserIfRegistred(values.email, values.password);
                // navigate(
                //   language === LOCALES.EN_US 
                //     ? `/dashboard/activities/${response?.payload?.response?.userId}?lang=${LOCALES.EN_US}`
                //     : `/instrumentbrada/aktiviteter/${response?.payload?.response?.userId}?lang=${LOCALES.SV_SE}`
                // );
              } else {
                const timeoutMilliseconds = 5000;

                const checkUserIdInterval = setInterval(() => {
                  if (response?.payload?.response?.userId) {
                    clearInterval(checkUserIdInterval);
                    loginUserIfRegistred(values.email, values.password);
                    // navigate(
                    //   language === LOCALES.EN_US
                    //     ? `/dashboard/activities/${response?.payload?.response?.userId}?lang=${LOCALES.EN_US}`
                    //     : `/instrumentbrada/aktiviteter/${response?.payload?.response?.userId}?lang=${LOCALES.SV_SE}`
                    // );
                  }
                }, 100);

                setTimeout(() => {
                  clearInterval(checkUserIdInterval);
                }, timeoutMilliseconds);
              }
            }
          }
        }
      }
    }
  };

  // Add hashEmail and pushHashedEmail functions
  async function hashEmail(email) {
    // Use CryptoJS for SHA-256 hashing
    const hash = CryptoJS.SHA256(email.trim().toLowerCase());
    return hash.toString(CryptoJS.enc.Hex);
  }

  async function pushHashedEmail(values) {
    const email = values.email;
    const isProduction = import.meta.env.VITE_NODE_ENV === "production";
    if (isProduction) {
      const hashedEmail = await hashEmail(email);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "create_account",
        email: hashedEmail,
      });
    }
  }

  return (
    <>
      {" "}
      <Layout
        className="sign-up-email new_sign_desns new_create new_sign_up new_margin_header"
        hidefooter
        headerColor="secondary"
      >
        <Helmet>
          <link rel="canonical" href="https://invozio.com/e-postregister" />
        </Helmet>
        {isLoading && <Loader />}
        <div className="logn_pge_dsgn create">
          <div className="container">
            <div className="row">
              <div className="col-md-6 remove_div">
                <DiscoverInvozio />
              </div>

              <div className="col-md-6 add_div_my">
                <div className="bg-light">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="d-flex align-items-center justify-content-between freeaccount">
                      <h1 className="mb-3 text-dark ">
                        {t("Create Free Account")}
                      </h1>
                      <Dropdown className="mb-4 drp_new_class">
                        <Dropdown.Toggle variant="primary createaccount_btn">
                          {accountType === "1"
                            ? t("For freelance & consultant")
                            : accountType === "2"
                            ? t("For Business")
                            : t("Select Your Account Type") ||
                              t("Select Your Account Type")}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            value={1}
                            onClick={(e) => {
                              navigate(
                                language === LOCALES.EN_US
                                  ? `/emailregister?lang=${LOCALES.EN_US}`
                                  : `/e-postregister?lang=${LOCALES.SV_SE}`
                              );
                              sessionStorage.setItem("accountType", 1);
                            }}
                          >
                            {t("For freelance & consultant")}
                          </Dropdown.Item>
                          <Dropdown.Item
                            defaultValue={2}
                            onClick={() => {
                              navigate(
                                language === LOCALES.EN_US
                                  ? `/emailregister?lang=${LOCALES.EN_US}`
                                  : `/e-postregister?lang=${LOCALES.SV_SE}`
                              );
                              sessionStorage.setItem("accountType", 2);
                            }}
                          >
                            {t("For Business")}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="mb-3 already-account">
                      {t("Already have an account")}?
                      <Link
                        to={
                          language === LOCALES.EN_US
                            ? `/emaillogin?lang=${LOCALES.EN_US}`
                            : `/e-postinloggning?lang=${LOCALES.SV_SE}`
                        }
                        style={{ textDecoration: "underline" }}
                      >
                        {" "}
                        {t("Sign in")}
                      </Link>
                    </div>
                    <div className="div_busnn">
                      {/* <label className="email_mns">Business Name</label> */}
                      <div className="d-flex mb-3">
                        <div className="w-100">
                          <label className="email_mns">
                            {t("First Name")}
                            <span
                              className="ml-2"
                              style={{ cursor: "pointer", position: "relative", display: "inline-block" }}
                              title={t("Allowed characters: a-z, A-Z, 0-9, space, comma, and Ö, Ä, Å, ö, ä, å")}
                            >
                              <AiOutlineInfoCircle size={16} color="#6c757d" />
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control m-0"
                            placeholder={t("First Name")}
                            required
                            {...register("firstName")}
                            onInput={handleTextInputChange}
                          />
                        </div>

                        <div className="ml-2 w-100">
                          <label className="email_mns">
                            {t("Last Name")}
                            <span
                              className="ml-2"
                              style={{ cursor: "pointer", position: "relative", display: "inline-block" }}
                              title={t("Allowed characters: a-z, A-Z, 0-9, space, comma, and Ö, Ä, Å, ö, ä, å")}
                            >
                              <AiOutlineInfoCircle size={16} color="#6c757d" />
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control m-0 w-100"
                            placeholder={t("Last Name")}
                            required
                            {...register("lastName")}
                            onInput={handleTextInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="div_busnn">
                      <div className="d-flex mb-3">
                        <div className="w-100">
                          <label className="email_mns">{t("Email")}</label>
                          <input
                            type="text"
                            className="form-control m-0"
                            placeholder={t("Email")}
                            required
                            {...register("email", {
                              pattern: {
                                value:
                                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: t("Invalid email address"),
                              },
                            })}
                          />
                        </div>
                        <div className="ml-2 w-100">
                          <label className="email_mns">
                            {t("Confirm Email")}
                          </label>
                          <input
                            type="text"
                            className="form-control m-0 w-100"
                            placeholder={t("Confirm Email")}
                            required
                            // Prevent copy, paste, and cut
                            onPaste={e => e.preventDefault()}
                            onCopy={e => e.preventDefault()}
                            onCut={e => e.preventDefault()}
                            {...register("confirmEmail", {
                              pattern: {
                                value:
                                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: t("Invalid email address"),
                              },
                              validate: (value) =>
                                value === watch("email") ||
                                t("The emails do not match"),
                            })}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="div_busnn">
                      <div className="d-flex mb-3">
                        <div className="w-100">
                          <label className="email_mns">
                            {t("Phone Number")}
                          </label>
                          <input
                            type="number"
                            min="0"
                            className="form-control w-100 m-0"
                            placeholder={t("Phone Number")}
                            required
                            {...register("phoneNo", {
                              pattern: {
                                value: /^\d+$/i,
                                message: "Invalid Phone Number",
                              },
                              maxLength: {
                                value: 13,
                                message: "Invalid Phone Number",
                              },
                              minLength: {
                                value: 8,
                                message: "Invalid Phone Number",
                              },
                            })}
                          />
                        </div>
                        <div className="w-100 ml-2">
                          <label className="email_mns">
                            {t("Your 12 digit SSN. No")}
                          </label>
                          <input
                            min="0"
                            readOnly={dateOfBirth}
                            className="form-control w-100 m-0"
                            placeholder={t("Your 12 digit SSN. No")}
                            onKeyDown={(e) => {
                              const inputValue = e.key;
                              const allowedCharacters =
                                /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                              if (
                                inputValue !== "Backspace" &&
                                !allowedCharacters.test(inputValue)
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onInput={(e) => {
                              const maxLength = 12;
                              e.target.value = e.target.value.replace(
                                /[^a-zA-Z0-9]/g,
                                ""
                              );

                              if (e.target.value.length > maxLength) {
                                e.target.value = e.target.value.slice(
                                  0,
                                  maxLength
                                );
                              }
                            }}
                            {...register("ssn", {
                              validate: (value) => {
                                if (value && value.length === 12) {
                                  const last4 = value.slice(-4);
                                  if (last4 === "0000") {
                                    return t("The last 4 digits of SSN cannot be all zeros.");
                                  }
                                }
                                return true;
                              }
                            })}
                          />
                          {/* Show error for SSN validation */}
                          {errors.ssn && (
                            <span className="text-danger" style={{ fontSize: "0.9em" }}>
                              {errors.ssn.message}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="checkbox-wrapper-37 mt-3 d-flex">
                      <input
                        type="checkbox"
                        name="checkbox"
                        id="terms-checkbox-37"
                        onClick={(e) => {
                          if (!e.target.checked) {
                            setDOBValue("");
                            setShow({
                              completeSuccessful: false,
                            });
                          }
                        }}
                        disabled={ssnNumber}
                        {...register("DOB")}
                      />
                      <label
                        htmlFor="terms-checkbox-37"
                        className="terms-label mr-2"
                      >
                        <CheckboxUI />
                      </label>
                      <span className="label-text">
                        {t("Do not have SSN. No.")}
                      </span>
                    </div>

                    <div className="d-flex flex-column transparent">
                      <div className="w-100 d-flex mb-2 text-left">
                        <div className="d-flex flex-column align-items-start spn_cls mt-1">
                          {dateOfBirth && (
                            <span
                              className={`${
                                show.complete || show.completeSuccessful
                                  ? "ml-4 text-success"
                                  : show.successMessage
                                  ? "text-success"
                                  : show.errorMessage
                                  ? "text-danger"
                                  : ""
                              }`}
                            >
                              {show.complete
                                ? t("Enter at least 3 digits randomly")
                                : show.completeSuccessful
                                ? t("Successful")
                                : t(
                                    "Date of birth should be in this Format Ex- 199810290000"
                                  )}
                            </span>
                          )}
                        </div>
                      </div>
                      {dateOfBirth && (
                        <input
                          autoFocus
                          type="number"
                          className="form-control w-100 m-0 mb-3"
                          value={DOBValue}
                          placeholder={t("YYYYMMDD000")}
                          {...register("dateBirth", {
                            onChange: (e) => {
                              const index = Array.from(e.target.value)[4];
                              if (e.target.value.length <= 11) {
                                setDOBValue(e.target.value);
                              }
                              if (
                                e.target.value >= 3 &&
                                e.target.value.length === 1
                              ) {
                                setShow({
                                  ...show,
                                  errorMessage: true,
                                  complete: false,
                                  successMessage: false,
                                  completeSuccessful: false,
                                });
                              } else if (
                                e.target.value.length === 0 ||
                                (index !== undefined && !index === 1) ||
                                index === 0
                              ) {
                                setShow({
                                  ...show,
                                  errorMessage: true,
                                  successMessage: false,
                                  complete: false,
                                  completeSuccessful: false,
                                });
                              } else if (
                                (e.target.value === 1 ||
                                  e.target.value === 2 ||
                                  e.target.value.length >= 5) &&
                                e.target.value.length < 8
                              ) {
                                setShow({
                                  ...show,
                                  errorMessage: false,
                                  complete: false,
                                  successMessage: true,
                                  completeSuccessful: false,
                                  acception: true,
                                });
                              } else if (
                                e.target.value.length === 8 &&
                                show.acception
                              ) {
                                setDOBValue(e.target.value + 0 + 0 + 0);
                                setShow({
                                  ...show,
                                  errorMessage: false,
                                  successMessage: true,
                                  complete: false,
                                  completeSuccessful: true,
                                  acception: false,
                                });
                              } else if (
                                e.target.value.length >= 8 &&
                                e.target.value.length < 11
                              ) {
                                setShow({
                                  ...show,
                                  errorMessage: false,
                                  successMessage: true,
                                  complete: true,
                                  completeSuccessful: false,
                                });
                              } else if (e.target.value.length === 11) {
                                setShow({
                                  ...show,
                                  errorMessage: false,
                                  successMessage: true,
                                  complete: false,
                                  completeSuccessful: true,
                                });
                              }
                            },
                          })}
                        />
                      )}
                    </div>
                    <div>
                      {freelancerInvitated && (
                        <>
                          <div className="div_busnn">
                            <div className="d-flex mb-3">
                              <div className="w-100">
                                <div className="mb-3 position-relative">
                                  <label htmlFor="inputAddress">Bank</label>
                                  <select
                                   style={{height: "38px"}}
                                    className="form-control styled-select select w-100"
                                    {...register("bank")}
                                  >
                                    <option> {t("Select a bank")} </option>
                                    <option value="Handelsbanken"> {t("Handelsbanken")} </option>
                                    <option value="Nordea social security number">
                                      {" "}
                                      {t("Nordea social security number")}
                                    </option>
                                    <option value="Nordea Account number">
                                      {" "}
                                      {t("Nordea Account number")}{" "}
                                    </option>
                                    <option value="Revolut Bank"> Revolut Bank </option>
                                    <option value="Swedbank"> Swedbank </option>
                                    <option value="SEB"> SEB </option>
                                    <option value="Foreign bank BIC / IBAN">
                                      {" "}
                                      {t("Foreign bank BIC / IBAN")}{" "}
                                    </option>
                                    <option value="Other Bank"> {t("Other Bank")} </option>
                                    {data?.bank !==
                                      ("Handelsbanken" ||
                                        "Nordea social security number" ||
                                        "Nordea Account number" ||
                                        "Revolut Bank" || 
                                        "Swedbank" ||
                                        "SEB" ||
                                        "Foreign bank BIC / IBAN") && (
                                      <option value={data?.bank}> {data?.bank} </option>
                                    )}
                                  </select>
                                </div>
                              </div>
                              <div className="w-100 ml-2">
                                {["Foreign bank BIC / IBAN", "Revolut Bank"].includes(bankName) ? (
                                  <div className="form-group input-wrapper mb-0">
                                      <label
                                      className="form-control-placeholder"
                                      htmlFor="ibanNumber"
                                    >
                                      {t("IBAN Number")}
                                    </label>
                                    <input
                                      autoFocus
                                      type="text"
                                      className={`form-control ${
                                        errors.ibanNumber ? "is-invalid" : ""
                                      }`}
                                      id="ibanNumber"
                                      {...register("ibanNumber", {
                                        required: ["Foreign bank BIC / IBAN", "Revolut Bank"].includes(bankName),
                                      })}
                                      required
                                    />
                                  </div>
                                ) : (
                                  <div className="form-group input-wrapper mb-0">
                                    <label htmlFor="inputCity"> {t("Clearing number")}</label>
                                    <input
                                      className={`form-control border-radius-0 w-100
                                    `}
                                      type="number"
                                      id="clearingNumber"
                                      {...register("clearingNumber", {
                                        required: !["Foreign bank BIC / IBAN", "Revolut Bank"].includes(bankName),
                                        validate: validateClearingNumber,
                                      })}
                                      onInput={(e) => {
                                        let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                                        if (value.length > 5) {
                                          value = value.substring(0, 5); // Limit to 5 digits
                                        }
                                        e.target.value = value;
                                        validateClearingNumber(e.target.value);
                                      }}
                                      required
                                    />
                                    {errors.clearingNumber && (
                                      <div className="invalid-feedbackk">
                                        {errors.clearingNumber.message}
                                      </div>
                                    )}
                                    {/*  */}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="div_busnn">
                            <div className="d-flex mb-3">
                               {bankName === "Other Bank" && (
                               <div className="w-100">
                                 
                                  <div className="mb-3 position-relative">
                                    <label
                                      htmlFor="Bank-Details"
                                      className="form-control-placeholder"
                                    >
                                      <span>Bank Name</span>
                                    </label>
                                    <input
                                      {...register("OtherBank")}
                                      id="Bank-Details"
                                      autoFocus
                                      placeholder="Your Bank Name Here"
                                      type="text"
                                      className="form-control styled-select select w-100 mb-4"
                                      required
                                    />
                                  </div>
                               </div> )}
                              <div className="w-100 ml-2">
                                {["Foreign bank BIC / IBAN", "Revolut Bank"].includes(bankName) ? (
                                  <div className="form-group input-wrapper mb-0">
                                     <label
                                      className="form-control-placeholder"
                                      htmlFor="bicNumber"
                                      style={{ zIndex: "1" }}
                                    >
                                      {t("BIC Number")}
                                    </label>
                                    <input
                                      className={`form-control border-radius-0 w-100`}
                                      type="text"
                                      id="bicNumber"
                                      {...register("bicNumber", {
                                        required: ["Foreign bank BIC / IBAN", "Revolut Bank"].includes(bankName),
                                      })}
                                      required
                                    />
                                  </div>
                                ) : (
                                  <div className="form-group input-wrapper mb-0">
                                    <label htmlFor="inputState"> {t("Account number")}</label>
                                    <input
                                      type="number"
                                      className={`form-control`}
                                      id="accountNumber"
                                      {...register("accountNumber", {
                                        required: !["Foreign bank BIC / IBAN", "Revolut Bank"].includes(bankName),
                                        validate: validateAccountNumber,
                                      })}
                                      onInput={(e) => {
                                        let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                                        if (value.length > 10) {
                                          value = value.substring(0, 10); // Limit to 10 digits
                                        }
                                        e.target.value = value;
                                        validateAccountNumber(e.target.value);
                                      }}
                                      required
                                    />
                                    {errors.accountNumber && (
                                      <div className="invalid-feedbackk">
                                        {errors.accountNumber.message}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="div_busnn">
                      <div className="d-flex mb-3">
                        <div className="w-100">
                          <label className="email_mns">{t("Profession")}</label>
                          <input
                            type="text"
                            className="form-control w-100 m-0"
                            placeholder={t("Profession")}
                            required
                            {...register("profession")}
                          />
                        </div>
                        <div className="w-100 ml-2">
                          <label className="email_mns">
                            {t("Address")}
                            <span
                              className="ml-2"
                              style={{ cursor: "pointer", position: "relative", display: "inline-block" }}
                              title={t("Allowed characters: a-z, A-Z, 0-9, space, comma, and Ö, Ä, Å, ö, ä, å")}
                            >
                              <AiOutlineInfoCircle size={16} color="#6c757d" />
                            </span>
                          </label>
                          <input
                            className="form-control w-100 m-0"
                            placeholder={t("Address")}
                            required
                            {...register("address")}
                            onInput={handleTextInputChange}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="div_busnn">
                      <div className="d-flex mb-3">
                        <div className="w-100">
                          <label className="email_mns">
                            {t("City")}
                            <span
                              className="ml-2"
                              style={{ cursor: "pointer", position: "relative", display: "inline-block" }}
                              title={t("Allowed characters: a-z, A-Z, 0-9, space, comma, and Ö, Ä, Å, ö, ä, å")}
                            >
                              <AiOutlineInfoCircle size={16} color="#6c757d" />
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control w-100 m-0"
                            placeholder={t("City")}
                            required
                            {...register("city")}
                            onInput={handleTextInputChange}
                          />
                        </div>
                        <div className="w-100 ml-2">
                          <label className="email_mns">{t("Country")}</label>
                          <select
                            className="form-control w-100 m-0"
                            required
                            {...register("country", { required: true })}
                          >
                            <option value="">{t("Select Country")}</option>
                            <option value={"Sweden"}>{"Sweden"}</option>
                            <option value={"USA"}>{"USA"}</option>
                            {newDetails.map((country, index) => (
                              <option key={index} value={country}>
                                {country}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="div_busnn">
                      <div className="d-flex mb-3">
                        <div className="w-100">
                          <label className="email_mns">
                            {t("Postal code")}
                          </label>
                          <input
                            type="number"
                            min="0"
                            className="form-control w-100 m-0"
                            placeholder={t("Postal code")}
                            required
                            {...register("postal")}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="d-flex mb-3 last">
                      <div className="w-100 change-password-icon mb-2">
                        <div>
                          <label className="email_mns">{t("Password")}</label>
                          <div className="input-group">
                            <div className="input-div">
                              <input
                                max="20"
                                type={passVisible ? "text" : "password"}
                                className="form-control mt-0 mb-0"
                                placeholder={t("Password")}
                                required
                                {...register("password", {
                                  minLength: {
                                    value: 8,
                                    message: t(
                                      "Password must be atleast 8 characters in length"
                                    ),
                                  },
                                  pattern: {
                                    value:
                                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/i,
                                    message: invalidPasswordChars.length > 0 
                                      ? `${t("Only letters, numbers, and these symbols are allowed: @$!%*?&")}. ${t("Invalid characters found:")} ${invalidPasswordChars.join(', ')}.`
                                      : t("Password must contain at least one capital letter and one number. Special characters like hyphens (-), accented letters (ö, ä, å, é, ñ, etc.), and symbols (€, £, ©, ®, etc.) are not accepted."),
                                  },
                                  onChange: (e) => {
                                    validatePasswordChars(e.target.value);
                                  }
                                })}
                              />
                            </div>
                            <div className="input-group-append pr-3">
                              {passVisible ? (
                                <AiOutlineEyeInvisible
                                  className="m-auto"
                                  size={24}
                                  onClick={() => setPassVisibile(false)}
                                />
                              ) : (
                                <AiOutlineEye
                                  className="m-auto"
                                  size={24}
                                  onClick={() => setPassVisibile(true)}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="w-100 change-password-icon ml-2">
                        <div>
                          <label className="email_mns">
                            {t("Confirm Password")}
                          </label>
                        </div>
                        <div className="input-group">
                          <div className="input-div">
                            <input
                              max="20"
                              type={passVisible ? "text" : "password"}
                              className="form-control mt-0 ml-0 mb-0"
                              placeholder={t("Confirm Password")}
                              required
                              {...register("confirmPassword", {
                                minLength: {
                                  value: 8,
                                  message: t(
                                    "Password must be atleast 8 characters in length"
                                  ),
                                },
                                pattern: {
                                  value:
                                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/i,
                                  message: invalidPasswordChars.length > 0 
                                    ? `${t("Only letters, numbers, and these symbols are allowed: @$!%*?&")}. ${t("Invalid characters found:")} ${invalidPasswordChars.join(', ')}.`
                                    : t("Password must contain at least one capital letter and one number. Special characters like hyphens (-), accented letters (ö, ä, å, é, ñ, etc.), and symbols (€, £, ©, ®, etc.) are not accepted."),
                                },
                                validate: (value) =>
                                  value === watch("password") ||
                                  t("The passwords do not match"),
                                onChange: (e) => {
                                  validatePasswordChars(e.target.value);
                                }
                              })}
                            />
                          </div>
                          <div className="input-group-append pr-3">
                            {passVisible ? (
                              <AiOutlineEyeInvisible
                                className="m-auto"
                                size={24}
                                onClick={() => setPassVisibile(false)}
                              />
                            ) : (
                              <AiOutlineEye
                                className="m-auto"
                                size={24}
                                onClick={() => setPassVisibile(true)}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {invalidPasswordChars.length > 0 && (
                      <div className="mt-2 mb-2" style={{ fontSize: "0.95em", color: "red", }}>
                        <span>{t("Invalid characters found:")} {invalidPasswordChars.join(', ')}</span>
                        <br />
                         <small>{t("Only letters, numbers, and these symbols are allowed: @$!%*?&")}</small>
                      </div>
                    )}
                    <div
                      className={`checkbox-wrapper-37 align-items-start ${
                        errors.customCheck ? "border-red" : ""
                      } mt-3 d-flex`}
                    >
                      <input
                        type="checkbox"
                        name="checkbox"
                        id="terms-checkbox-38"
                        checked={isTermsChecked}
                        onChange={(e) => {
                          setIsTermsChecked(e.target.checked);
                        }}
                        {...register("customCheck", {
                          required: t("Please select the terms and condition"),
                          // keep react-hook-form validation
                          onChange: (e) => setIsTermsChecked(e.target.checked),
                        })}
                      />
                      <label
                        htmlFor="terms-checkbox-38"
                        className="terms-label mr-2"
                      >
                        <svg
                          className={`checkbox-svg ${
                            isTermsChecked ? "svg-border-green" : "svg-border-red"
                          }`}
                          viewBox="0 0 200 200"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask id="path-1-inside-1_476_5-37" fill="white">
                            <rect width="200" height="200" />
                          </mask>
                          <rect
                            width="200"
                            height="200"
                            className="checkbox-box"
                            strokeWidth="40"
                            mask="url(#path-1-inside-1_476_5-37)"
                          />
                          <path
                            className="checkbox-tick"
                            d="M52 111.018L76.9867 136L149 64"
                            strokeWidth="15"
                          />
                        </svg>
                      </label>
                      <span className="label-text">
                        {t(
                          "I hereby confirm that I have read, understood, and accepted the applicable "
                        )}
                        <a
                          className=" how_calculate_link"
                          href={
                            language === LOCALES.EN_US
                              ? workAgrementEnglish
                              : workAgrementSwedish
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {t("general terms and conditions as of the current date")}
                        </a>
                        , {t("including the right to work, the general fixed-term employment agreement, and the")}{" "}
                        <a
                          className=" how_calculate_link"
                          href={
                            language === LOCALES.EN_US ? invoicePDF : invoiceSwidishPDF
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {t("annex concerning the processing of personal data.")}
                        </a>
                      </span>
                    </div>
                    {Object.keys(errors).length > 0 && (
                      <div className="text-center w-100">
                        <p className="text-danger">
                          {errors[Object.keys(errors)[0]]?.message}
                        </p>
                      </div>
                    )}
                    <Button
                      variant="primary "
                      type="submit"
                      className="mt-4 text-light filled new_theme_btn mb-3"
                      size="lg"
                    >
                      {t("Create Free Account")}
                    </Button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
      <section className="new_scts trustplot_sctn new_desig_tooltip_ca pb-5">
        <div className="container container-dynamic pb-0">
          <div
            className="trustpilot-widget"
            data-locale={LOCALES.SV_SE}
            data-template-id="5406e65db0d04a09e042d5fc"
            data-businessunit-id="64f712e3dbd20bbfcf3a825f"
            data-style-height="28px"
            data-style-width="100%"
            data-theme="light"
          >
            <a
              href="https://se.trustpilot.com/review/invozio.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Trustpilot
            </a>
          </div>
        </div>
      </section>
      <div className="footer_below dashbrd_foter_below_ca">
        <SlideComp />
      </div>
    </>
  );
};
export default CreateAccount;
